const Moment = require('moment');

module.exports = (FECHA, IMPORTE, REFERENCIA) => {
  // Date object
  console.log(`FECHA ${FECHA}`);
  const date = new Moment(FECHA, 'DD/MM/YYYY');
  // Current Year as string
  const C_ANIO = date.format('YYYY');
  // Current Month as string
  const C_MES = date.format('MM');
  // Current Day as string
  const C_DIA = date.format('DD');

  // Current Year as integer
  const P_ANIO = parseInt(C_ANIO, 10);
  // Current Month as integer
  const P_MES = parseInt(C_MES, 10);
  // Current Day as integer
  const P_DIA = parseInt(C_DIA, 10);

  let LINEA_BANCOS;
  let LINEA_OXXO;
  let V_ANIO;
  let V_MES;
  let V_DIA;
  let V_FECHA_CONDENSADA;
  let V_IMPORTE;
  let V_IMPORTE_INT;
  let X;
  let V_SUMATORIA;
  let V_MULTIPLO;
  let V_REMANENTE;
  let V_REFERENCIA;
  let V_DIGITOS_VERIFICADORES;
  let V_LONGITUD;
  let V_CENTAVOS_CHAR;
  let V_CENTAVOS_INT;
  let FECHA_CONDENSADA_CHAR;

  /* IMPORTE MÁXIMO COBRABLE POR EL BANCO ES DE 999,999 */
  if (IMPORTE > 999999 && ['1133', '1113'].includes(REFERENCIA.substring(0, 4))) {
    LINEA_BANCOS = '';
  } else {
    /* CALCULO DE LA FECHA LÍMITE DE PAGO CONDENSADA */
    V_ANIO = (P_ANIO - 2014) * 372;
    V_MES = (P_MES - 1) * 31;
    V_DIA = (P_DIA - 1);
    V_FECHA_CONDENSADA = V_ANIO + V_MES + V_DIA;
    FECHA_CONDENSADA_CHAR = V_FECHA_CONDENSADA.toString().padStart(4, '0');

    /*  CALCULO DE LA FORMA CONDENSADA DE IMPORTE */
    V_IMPORTE_INT = Math.floor(IMPORTE);
    V_CENTAVOS_INT = Math.round((IMPORTE - V_IMPORTE_INT) * 100);

    if (V_CENTAVOS_INT < 0) {
      V_IMPORTE_INT -= 1;
      V_CENTAVOS_INT = Math.round((IMPORTE - V_IMPORTE_INT) * 100);
    }
    V_CENTAVOS_CHAR = V_CENTAVOS_INT.toString().padStart(2, '0');

    V_IMPORTE = V_IMPORTE_INT.toString().padStart(9, '0') + V_CENTAVOS_CHAR;
    X = 1;
    V_MULTIPLO = 3;
    V_SUMATORIA = 0;

    while (X <= 11) {
      V_SUMATORIA += parseInt(V_IMPORTE.substring(X - 1, X), 10) * V_MULTIPLO;

      if (V_MULTIPLO === 3) {
        V_MULTIPLO = 7;
      } else if (V_MULTIPLO === 7) {
        V_MULTIPLO = 1;
      } else {
        V_MULTIPLO = 3;
      }

      X += 1;
    }

    V_REMANENTE = V_SUMATORIA - (Math.floor(V_SUMATORIA / 10) * 10);

    /* CALCULO DE LOS DIGITOS VERIFICADORES GLOBALES */
    X = 1;
    V_REFERENCIA = '';
    while (X <= REFERENCIA.length) {
      let suffix;
      const substr = REFERENCIA.substring(X - 1, X);
      if (/A|B|C|2/.test(substr)) {
        suffix = '2';
      } else if (/D|E|F|3/.test(substr)) {
        suffix = '3';
      } else if (/G|H|I|4/.test(substr)) {
        suffix = '4';
      } else if (/J|K|L|5/.test(substr)) {
        suffix = '5';
      } else if (/M|N|O|6/.test(substr)) {
        suffix = '6';
      } else if (/P|Q|R|7/.test(substr)) {
        suffix = '7';
      } else if (/S|T|U|8/.test(substr)) {
        suffix = '8';
      } else if (/V|W|X|9/.test(substr)) {
        suffix = '9';
      } else if (/Y|Z|0/.test(substr)) {
        suffix = '0';
      } else if (/1/.test(substr)) {
        suffix = '1';
      } else {
        suffix = '';
      }
      V_REFERENCIA += suffix;
      X += 1;
    }

    V_REFERENCIA = `${V_REFERENCIA.padStart(32, ' ') + FECHA_CONDENSADA_CHAR + V_REMANENTE.toString()}2`;

    X = 1;
    V_MULTIPLO = 17;
    V_SUMATORIA = 0;

    while (X <= 38) {
      const substr = V_REFERENCIA.substring(X - 1, X);
      if (substr !== ' ') {
        V_SUMATORIA += V_MULTIPLO * parseInt(substr, 10);
      }
      if (V_MULTIPLO === 17) {
        V_MULTIPLO = 13;
      } else if (V_MULTIPLO === 13) {
        V_MULTIPLO = 11;
      } else if (V_MULTIPLO === 11) {
        V_MULTIPLO = 23;
      } else if (V_MULTIPLO === 23) {
        V_MULTIPLO = 19;
      } else {
        V_MULTIPLO = 17;
      }
      X += 1;
    }

    V_SUMATORIA -= 97 * Math.floor(V_SUMATORIA / 97);
    V_SUMATORIA += 1;

    V_DIGITOS_VERIFICADORES = V_SUMATORIA.toString().padStart(2, '0');
    V_REFERENCIA += V_DIGITOS_VERIFICADORES;
    LINEA_BANCOS = V_REFERENCIA.trimStart();
  }
  /* EL IMPORTE MÁXIMO COBRABLE EN OXXO ES DE 10,000 */
  if (IMPORTE > 10000) {
    LINEA_OXXO = '';
  } else {
    LINEA_OXXO = C_DIA + C_MES + C_ANIO;
    LINEA_OXXO = REFERENCIA + LINEA_OXXO;

    V_IMPORTE_INT = Math.floor(IMPORTE);
    V_CENTAVOS_INT = Math.round((IMPORTE - V_IMPORTE_INT) * 100);

    if (V_CENTAVOS_INT < 0) {
      V_IMPORTE_INT -= 1;
      V_CENTAVOS_INT = Math.round((IMPORTE - V_IMPORTE_INT) * 100);
    }

    V_CENTAVOS_CHAR = V_CENTAVOS_INT.toString().substring(0, 2).padStart(2, '0');
    LINEA_OXXO += V_IMPORTE_INT.toString().padStart(6, '0') + V_CENTAVOS_CHAR;

    V_LONGITUD = 0;
    V_MULTIPLO = 1;
    V_SUMATORIA = 0;

    while (V_LONGITUD < LINEA_OXXO.length) {
      V_LONGITUD += 1;
      V_SUMATORIA += (V_MULTIPLO * parseInt(LINEA_OXXO.substring(V_LONGITUD - 1, V_LONGITUD), 10));

      if (V_MULTIPLO === 1) {
        V_MULTIPLO = 3;
      } else if (V_MULTIPLO === 3) {
        V_MULTIPLO = 7;
      } else {
        V_MULTIPLO = 1;
      }
    }

    V_SUMATORIA %= 9;
    V_SUMATORIA += 1;

    LINEA_OXXO += V_SUMATORIA.toString();
  }
  return {
    LINEA_BANCOS,
    LINEA_OXXO,
  };
};
